import { Vue } from 'vue-property-decorator';

export function CheckBeforeExecution(
    shouldExecute: (ctx: Vue) => Promise<boolean> | boolean, // `ctx` - это `this` компонента
    errorHandler?: (ctx: Vue) => void,
) {
    return function (_target: any, _key: string, descriptor: PropertyDescriptor) {
        const originalMethod = descriptor.value;

        descriptor.value = async function (...args: any[]) {
            const self = this as Vue; // Привязываем `this` к компоненту

            const result = shouldExecute(self); // Call function

            const shouldProceed = result instanceof Promise ? await result : result; // Handle both sync & async

            if (shouldProceed) {
                return originalMethod.apply(self, args);
            } else {
                if (errorHandler) errorHandler(self);
            }
        };

        return descriptor;
    };
}
